const getDateMonthYear = (dateMs: string | number | Date = Date.now()) => {
  const dateStr = new Date(dateMs);
  const date = dateStr.getDate();
  const month = dateStr.getMonth();
  const year = dateStr.getFullYear();

  return [date, month, year] as const;
};

export default getDateMonthYear;
